import { Box } from '@mui/material';
import { useAudioPlayer } from '@contexts/AudioPlayerContext';
import Footer from '@components/shared/Footer';

export default function AppContent({ children }) {
  const { currentEpisode } = useAudioPlayer();

  // Keep content above the fixed player and the iOS home-indicator inset.
  const bottomPadding = currentEpisode
    ? { xs: 'calc(104px + env(safe-area-inset-bottom))', sm: '60px' }
    : 0;

  return (
    <Box
      sx={{
        pb: bottomPadding,
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        transition: 'padding-bottom 0.3s ease-in-out'
      }}
    >
      <Box sx={{ flexGrow: 1 }}>
        {children}
      </Box>
      <Footer />
    </Box>
  );
}
